// utils/preEmploymentUtils.ts

import type { StatusOption } from '../types/preEmployment.types';

// Constantes
export const STATUS_OPTIONS: StatusOption[] = [
  {
    id: "FIT_ALL_AREAS",
    label: "Fit in all areas",
    description:
      "le candidat n'a aucun problème médical, il peut exercer l'emploi prévu.",
  },
  {
    id: "FIT_RISK_1",
    label: "Fit Risk 1",
    description:
      "le candidat a un léger problème médical qui peut être corrigé sans problème : il peut exercer l'emploi prévu avec un traitement adéquat.",
  },
  {
    id: "FIT_RISK_2",
    label: "Fit Risk 2",
    description:
      "le candidat a un problème médical qui nécessite un traitement plus approfondi, mais il peut exercer l'emploi prévu.",
  },
  {
    id: "UNFIT_RISK_3",
    label: "Unfit Risk 3",
    description:
      "son état de santé ne lui permet pas d'exercer l'emploi prévu. Dans ce cas, quelles que soient les qualités, techniques ou comportementales du candidat, il sera éliminé du processus, et pourra approcher le médecin du Cabinet médical qui l'informera de ses problèmes de santé.",
  },
];

export const CLINIC_INFO = {
  name: "MIMAP",
  fullName: "MAURITANIA INTERNAL MEDICINE AND PEDIATRICS",
  address: "NOUAKCHOTT - Ilot K EXT 929",
  phone: "+222 41244404 / +222 31244404",
  email: "cabinetmimap@gmail.com",
};

// Utilitaires
export const generateCertificateNumber = (): string => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  
  return `${day}/${month}/${year}/MIMP-${hours}${minutes}-${randomNum}`;
};

interface PatientInfo {
  dateNaissance?: string;
  dateOfBirth?: string;
  birth_date?: string;
  lieuNaissance?: string;
  birthPlace?: string;
  adresse?: string;
  address?: string;
  ville?: string;
  city?: string;
}

interface ConsultationData {
  patientInfo?: PatientInfo;
  dateNaissance?: string;
  dateOfBirth?: string;
  birth_date?: string;
  lieuNaissance?: string;
  birthPlace?: string;
  adresse?: string;
  address?: string;
  ville?: string;
  city?: string;
}

export const extractDateOfBirth = (consultationData: ConsultationData): string => {
  const dateCandidates = [
    consultationData?.patientInfo?.dateNaissance,
    consultationData?.dateNaissance, 
    consultationData?.dateOfBirth,
    consultationData?.patientInfo?.dateOfBirth,
    consultationData?.patientInfo?.birth_date,
    consultationData?.birth_date
  ];
  
  for (const dateValue of dateCandidates) {
    if (dateValue) {
      try {
        // Si c'est déjà une chaîne au format DD/MM/YYYY
        if (typeof dateValue === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
          return dateValue;
        }
        
        // Si c'est une chaîne au format YYYY-MM-DD
        if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
          const date = new Date(dateValue);
          return date.toLocaleDateString("fr-FR");
        }
        
        // Tentative de conversion générale
        const date = new Date(dateValue);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString("fr-FR");
        }
      } catch {
        // Continue to next candidate
      }
    }
  }
  
  return "Date non définie";
};

export const extractBirthPlace = (consultationData: ConsultationData): string => {
  const placeCandidates = [
    consultationData?.patientInfo?.lieuNaissance,
    consultationData?.lieuNaissance,
    consultationData?.birthPlace,
    consultationData?.patientInfo?.birthPlace,
    consultationData?.patientInfo?.adresse,
    consultationData?.adresse,
    consultationData?.address,
    consultationData?.patientInfo?.address,
    consultationData?.patientInfo?.ville,
    consultationData?.ville,
    consultationData?.city
  ];
  
  for (const place of placeCandidates) {
    if (place !== null && place !== undefined) {
      const placeStr = String(place).trim();
      
      if (placeStr && placeStr !== 'null' && placeStr !== 'undefined') {
        return placeStr;
      }
    }
  }
  
  return "Nouakchott, Mauritanie";
};

export const getStatusText = (statusId: string): string => {
  switch (statusId) {
    case "FIT_ALL_AREAS":
      return "Fit in all areas : le candidat n'a aucun problème médical, il peut exercer l'emploi prévu.";
    case "FIT_RISK_1":
      return "Fit Risk 1 : le candidat a un léger problème médical qui peut être corrigé sans problème : il peut exercer l'emploi prévu avec un traitement adéquat.";
    case "FIT_RISK_2":
      return "Fit Risk 2 : le candidat a un problème médical qui nécessite un traitement plus approfondi, mais il peut exercer l'emploi prévu.";
    case "UNFIT_RISK_3":
      return "Unfit Risk 3 : son état de santé ne lui permet pas d'exercer l'emploi prévu...";
    default:
      return "";
  }
};